import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import { useAuth } from '../../contexts/AuthContext';

const AdminNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const adminNavigationItems = [
    { label: 'Dashboard', path: '/admin-dashboard', icon: 'LayoutDashboard' },
    { label: 'Gerenciar Conteúdo', path: '/content-management', icon: 'FolderOpen' },
    { label: 'Categorias', path: '/category-management', icon: 'Grid' },
    { label: 'Administradores', path: '/admin-users', icon: 'Users' },
    { label: 'Configurações', path: '/admin-settings', icon: 'Settings' },
  ];

  const isActive = (path) => location?.pathname === path;

  const handleBack = () => {
    navigate(-1);
  };

  const handleLogout = async () => {
    if (window.confirm('Deseja realmente sair do painel administrativo?')) {
      await signOut();
      navigate('/admin-login');
    }
  };

  return (
    <nav className="admin-nav">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button
            onClick={handleBack}
            className="flex items-center gap-2 px-3 py-2 rounded-md font-medium text-foreground hover:text-primary hover:glow-primary-hover transition-smooth"
            aria-label="Voltar"
          >
            <Icon name="ArrowLeft" size={20} />
            <span className="hidden md:inline">Voltar</span>
          </button>
          <div className="w-8 h-8 rounded-md flex items-center justify-center bg-primary/10 glow-primary">
            <Icon name="Shield" size={20} color="var(--color-primary)" />
          </div>
          <span className="text-lg font-heading font-bold text-primary">
            Admin Panel
          </span>
        </div>

        <div className="flex items-center gap-6">
          {adminNavigationItems?.map((item) => (
            <Link
              key={item?.path}
              to={item?.path}
              className={`flex items-center gap-2 px-4 py-2 rounded-md font-medium transition-smooth ${
                isActive(item?.path)
                  ? 'text-primary glow-primary' :'text-foreground hover:text-primary hover:glow-primary-hover'
              }`}
            >
              <Icon name={item?.icon} size={18} />
              <span className="hidden sm:inline">{item?.label}</span>
            </Link>
          ))}
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 px-4 py-2 rounded-md font-medium bg-red-500/10 text-red-500 hover:bg-red-500/20 transition-smooth"
          >
            <Icon name="LogOut" size={18} />
            <span className="hidden sm:inline">Sair</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavigation;